import React, { useEffect, useRef, useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
  CircularProgress,
  Divider,
} from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import classNames from 'classnames'
import mapValues from 'lodash/mapValues'
import CustomAlert from '../../CustomAlert'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { parseDate } from '../../Models/CommonFunc'
import { Helmet } from 'react-helmet'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { getSupplyBillsDocumentCount, updateSupplyBillsDocument } from '../../../Backend/firebase/supply-bills'
import db from '../../../Backend/firebase/firebase'
import { createExtraMedicineDocument, getAllChemistUsersDocument, getAllSupplyOrderDocument, getExtraMedicineForSupply } from '../../../Backend/firebase/supply-order'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from 'xlsx';
import { extractNumber } from '../../../mock'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { loadAllMedicine } from '../../../mock/common'

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function EditSupplyOrderWithInvoice() {
  const { register, handleSubmit, errors, reset, setValue } = useForm()
  const classes = useStyles()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [InvoiceDate, setInvoiceDate] = useState(parseDate(new Date()))
  const [previewState, setPreviewState] = useState({})
  const [isPreview, setIsPreview] = useState(false)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [isChemistManully, setIsChemistManully] = useState(false)
  const { userData } = CheckUserProvider()
  const [records, setRecords] = useState([]);
  const [chemistEntry, setChemistEntry] = useState([])
  const [chemistItems, setChemistItems] = useState([])
  const tableRef = useRef();
  const xlsxTableRef = useRef();
  const DEFAULT_DISCOUNT = 6;
  const DEFAULT_TAX = 12;

  const [InvoiceNoCount, setInvoiceNoCount] = useState('');
  const [InvoiceNo, setInvoiceNo] = useState('');
  const [BillType, setBillType] = useState('Select Option');
  var batch = db.batch()
  const [selectedItems, setSelectedItems] = useState([]);

  const [brandedProductItems, setBrandedProductItems] = useState([])
  const [genericProductItems, setGenericProductItems] = useState([])
  const [ProductQuantity, setProductQuantity] = useState("")
  const [tabIndex, setTabIndex] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [PackagingSize, setPackagingSize] = useState('');
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    // Retrieve the invoice data from cookies
    const storedInvoice = localStorage.getItem('invoiceRecord');
    if (storedInvoice) {
      let record = JSON.parse(storedInvoice);
      setInvoice(record);

      setBillType(record?.BillType);
      setSelectedItems(record?.ProductEntry);
      setInvoiceNo(record?.InvoiceNo);
      setChemistEntry(record?.chemistEntry);
    }
  }, []);

  const loadPersistedData = async () => {
    const uniqueData = await loadAllMedicine();
    setBrandedProductItems(uniqueData);
    setGenericProductItems(uniqueData);
  };

  useEffect(async () => {
    try {
      loadPersistedData();
    } catch (error) {
      console.log('Error Occur in Get Products And Sales', error)
    }
  }, [])

  // Handle input change and filter suggestions
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value) {
      const filtered = tabIndex == 0 ? brandedProductItems?.filter((productItem) =>
        productItem?.ProductName.toLowerCase().includes(value.toLowerCase())
      ) : genericProductItems?.filter((productItem) =>
        productItem?.ProductName.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(filtered);
    } else {
      setFilteredSuggestions([]);
    }
  };

  // Handle suggestion click (only set inputValue, do not add to selected items)
  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion?.ProductName);
    setPackagingSize(suggestion?.PackagingSize);
    setFilteredSuggestions([]); // Hide suggestions after selecting one
  };

  const onTapAddProductButton = () => {
    if (inputValue && ProductQuantity != "") {
      let item = tabIndex == 0 ? brandedProductItems.find(s => s.ProductName.toLowerCase() === inputValue.toLowerCase()) : genericProductItems.find(s => s.ProductName.toLowerCase() === inputValue.toLowerCase());
      if (!item) {
        item = {
          _id: tabIndex == 0 ? brandedProductItems.length + 1 : genericProductItems.length + 1,
          ProductName: inputValue,
          PackagingSize,
          ProductQuantity,
          MedicineType: tabIndex == 0 ? 'Branded' : 'Generic',
          DiscountAmount: DEFAULT_DISCOUNT,
          Tax: DEFAULT_TAX
        };
        tabIndex == 0 ? setBrandedProductItems([...brandedProductItems, item]) : setGenericProductItems([...genericProductItems, item]);

        //Added Extra Medicine 
        var newMedicine = {};
        newMedicine.userId = userData.uid;
        newMedicine.ProductName = inputValue;
        try {
          var createdMedicine = createExtraMedicineDocument(newMedicine);
          if (createdMedicine) {
            console.log('Extra Medicine Added Successfully');
          } else {
            console.log('Extra Medicine Not Added Successfully');
          }
        } catch (error) {
          console.error(error);
        }
      }
      setSelectedItems([
        ...selectedItems,
        {
          ...item,
          PackagingSize,
          ProductQuantity,
          MedicineType: tabIndex == 0 ? 'Branded' : 'Generic',
          DiscountAmount: DEFAULT_DISCOUNT,
          Tax: DEFAULT_TAX
        }
      ]);

      setInputValue('');
      setPackagingSize('');
      setProductQuantity(0);
      setFilteredSuggestions([]); // Clear suggestions
    } else {
      setNotificationMessage('Please Search Medication and add Product Quantity!');
      setOpenNotify(true);
      setAlertType('error');
    }
  }

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  useEffect(async () => {
    try {
      const getSupplyBillsCount = await getSupplyBillsDocumentCount();
      setInvoiceNoCount(getSupplyBillsCount);
    } catch (error) {
      console.log("Error Occur in Get Sales Bills", error)
    }
  }, []);

  useEffect(async () => {
    if (userData) {
      try {
        const getChemistDetails = await getAllChemistUsersDocument()
        setChemistItems(getChemistDetails)
      } catch (error) {
        console.log('Error Occur in Get Products And Sales', error)
      }
    }
  }, [userData])

  const onSubmit = async (data) => {
    console.log('on Tap Submit')
  }

  const handlePreviewSubmit = () => {
    if (selectedItems?.length > 0) {
      setSelectedItems(selectedItems);
      handleSubmit(async (data) => {
        const newSupplyBills = {
          userId: userData.uid,
          BillType: data.BillType,
          storeName: data.storeName,
          storeAddress: data.storeAddress,
          phoneNumber: data.phoneNumber,
          email: data.email,
          gstNo: data.gstNo,
          drugLicense: data.drugLicense,
          InvoiceNo: data.InvoiceNo,
          InvoiceDate: InvoiceDate,
          ProductEntry: selectedItems,
          chemistEntry,
        };
        setPreviewState(newSupplyBills);
        setIsPreview(true);
      })();
    } else {
      setNotificationMessage('Please Select Product for generate Invoice!!')
      setOpenNotify(true)
      setAlertType('error')
      setIsLoading(false)
    }
  };

  const handleSaveSubmit = () => {
    if (previewState?.ProductEntry?.length > 0) {
      const isConfirmed = window.confirm("Are you sure you want to generate invoice?");
      if (isConfirmed) {
        handleSubmit(async (data) => {
          setIsLoading(true)

          var newSupplyBills = {}
          newSupplyBills._id = invoice._id;
          newSupplyBills.uniqueId = invoice.uniqueId;
          newSupplyBills.userId = userData.uid;
          newSupplyBills.BillType = previewState.BillType;
          newSupplyBills.storeName = previewState?.storeName ? previewState.storeName : null;
          newSupplyBills.storeAddress = previewState?.storeAddress ? previewState.storeAddress : null;
          newSupplyBills.phoneNumber = previewState?.phoneNumber ? previewState.phoneNumber : null;
          newSupplyBills.email = previewState?.email ? previewState.email : null;
          newSupplyBills.gstNo = previewState?.gstNo ? previewState.gstNo : null;
          newSupplyBills.drugLicense = previewState?.drugLicense ? previewState.drugLicense : null;
          newSupplyBills.InvoiceNo = previewState.InvoiceNo;
          newSupplyBills.InvoiceDate = InvoiceDate;
          newSupplyBills.ProductEntry = previewState.ProductEntry;
          newSupplyBills.chemistEntry = chemistEntry;
          newSupplyBills.GSTValue = finalCalculation()?.TotalGST;
          newSupplyBills.GrossValue = finalCalculation()?.TotalGrossAmount;
          newSupplyBills.DiscountAmount = finalCalculation()?.TotalDiscount;
          newSupplyBills.TotalAmount = finalCalculation()?.NetAmount;
          try {
            var salesBills = updateSupplyBillsDocument(newSupplyBills)
            if (salesBills) {
              setNotificationMessage('Invoice Update Successfully!')
              setOpenNotify(true)
              setAlertType('success')
              reset()
              setIsLoading(false)
              setTimeout(routeToPages, 500)
            } else {
              setNotificationMessage(
                'Something went wrong, Please try again later!!',
              )
              setOpenNotify(true)
              setAlertType('error')
              setIsLoading(false)
              history.push('/supply/generate-invoice')
            }
          } catch (error) {
            console.error(error)
            setNotificationMessage('Something went wrong, Please try again later!!')
            setOpenNotify(true)
            setAlertType('error')
            setIsLoading(false)
            history.push('/supply/generate-invoice')
          }
        })()
      } else {
        console.log("Form submission canceled.");
      }
    } else {
      setNotificationMessage('Please Select Product for generate Invoice!!')
      setOpenNotify(true)
      setAlertType('error')
      setIsLoading(false)
    }
  }

  const editPreview = () => {
    setIsPreview(false)
    setTimeout(() => {
      mapValues(previewState, (value, key) => setValue(key, value))
    })
  }

  const convertToSlug = (input) => input?.toLowerCase()?.replace(/[^a-z0-9\s]/g, '')?.replace(/\s+/g, '_');
  const downloadInvoice = (callback) => {
    const tableElement = tableRef.current;
    if (!tableElement) return;

    html2canvas(tableElement).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 190; // Full width for A4
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      // Convert PDF to Blob URL for preview
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open PDF in new tab
      window.open(pdfUrl, "_blank");

      // Save the PDF
      const fileName = previewState?.storeName ? `${convertToSlug(previewState?.storeName)}` : previewState?.chemistEntry?.storeName ? `${convertToSlug(previewState?.chemistEntry?.storeName)}` : "invoice";
      pdf.save(`${fileName}.pdf`);

      downloadInvoiceinXLSX();

      // Invoke callback after download
      if (callback) callback();
    });
  };
  
  const downloadInvoiceinXLSX = () => {
    const dataTableElement = xlsxTableRef.current;
    if (!dataTableElement) return;

    const wb = XLSX.utils.book_new();

    const InvoiceInfo = [
      [
        "Butame Pharma India Pvt. Ltd.",
        "",
        "",
        "Party Name:",
        previewState?.storeName || previewState?.chemistEntry?.storeName || "NA",
        "",
      ],
      [
        userData?.storeAddress || "",
        "",
        "",
        "Invoice No:",
        previewState?.InvoiceNo || "NA",
        "",
      ],
      [
        `Contact No: ${userData?.phoneNumber || ""}`,
        "",
        "",
        "Invoice Date:",
        previewState?.InvoiceDate || "NA",
        "",
      ],
      [
        `Email Id: ${userData?.email || "NA"}`,
        "",
        "",
        "",
        "",
        "",
      ],
      [
        `GST No: ${userData?.gstNo || "NA"}`,
        "",
        "",
        "",
        "",
        "",
      ],
      [
        `DL No: ${userData?.drugLicense || "NA"}`,
        "",
        "",
        "",
        "",
        "",
      ],
      [], // Empty row for spacing
    ];

    // Merging cells by groups of three columns
    const finalWs = XLSX.utils.aoa_to_sheet(InvoiceInfo);

    // Merge cells clearly for better visual presentation
    finalWs["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 2 } },
      { s: { r: 3, c: 0 }, e: { r: 3, c: 2 } },
      { s: { r: 4, c: 0 }, e: { r: 4, c: 2 } },
      { s: { r: 5, c: 0 }, e: { r: 5, c: 2 } },

      { s: { r: 0, c: 4 }, e: { r: 0, c: 5 } },
      { s: { r: 1, c: 4 }, e: { r: 1, c: 5 } },
      { s: { r: 2, c: 4 }, e: { r: 2, c: 5 } },
    ];

    // Now your existing logic for main table (dataTableElement)
    const ws = XLSX.utils.table_to_sheet(dataTableElement, { raw: true });

    // Your existing headerData logic remains untouched
    const header = dataTableElement.querySelectorAll('thead tr');
    const headerData = Array.from(header).map(row => {
      return Array.from(row.querySelectorAll('td')).map(cell => cell.innerText);
    });

    if (headerData.length > 0) {
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let i = 0; i < headerData.length; i++) {
        const rowIndex = range.s.r - headerData.length + i;
        headerData[i].forEach((cell, j) => {
          const cellAddress = { r: rowIndex, c: j };
          ws[XLSX.utils.encode_cell(cellAddress)] = { v: cell };
        });
      }
    }

    const dataJson = XLSX.utils.sheet_to_json(ws, { header: 1 });

    // Combine InvoiceInfo and main table data
    const finalSheetData = [...InvoiceInfo, ...dataJson];

    // Create final worksheet clearly again to include all combined data and merges
    const completeFinalWs = XLSX.utils.aoa_to_sheet(finalSheetData);

    // Re-apply merge rules to the complete worksheet
    completeFinalWs["!merges"] = finalWs["!merges"];

    // Append final worksheet
    XLSX.utils.book_append_sheet(wb, completeFinalWs, "Invoice");

    const fileName = previewState?.storeName
      ? `${convertToSlug(previewState.storeName)}.xlsx`
      : previewState?.chemistEntry?.storeName
        ? `${convertToSlug(previewState.chemistEntry.storeName)}.xlsx`
        : "invoice.xlsx";

    XLSX.writeFile(wb, fileName);
  };

  const printInvoice = (callback) => {
    const printContents = tableRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;

    // Ensure navigation happens after print dialog closes
    setTimeout(() => {
      if (callback) callback();
    }, 100);
  };

  const routeToPages = () => {
    downloadInvoice(() => {
      history.push('/supply/invoice-history');
    });
  }

  const handleInvoiceDateChange = (e) => {
    setInvoiceDate(parseDate(e.target.value))
  }

  const handleOnSearch = (string, results) => {
    console.log('handleOnSearch', string, results)
  }

  const handleOnHover = (result) => {
    console.log('handleOnHover', result)
  }

  const handleOnSelectChemist = (item) => {
    setChemistEntry(item)
    setTimeout(() => {
      mapValues(item, (value, key) => setValue(key, value))
    })
  }

  const handleOnFocus = () => {
    console.log('Focused')
  }

  const formatResultChemist = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left', zIndex: 9999 }}>
          {item.storeName} {item.storeAddress}
        </span>
      </>
    )
  }

  const finalCalculation = () => {

    // Initialize accumulators for totals
    let totalGrossAmount = 0;
    let totalDiscount = 0;
    let totalGst = 0;
    let netAmount = 0;

    // Iterate over the array and perform calculations
    if (previewState && previewState?.ProductEntry && previewState?.ProductEntry?.length > 0) {

      previewState?.ProductEntry.forEach((product) => {
        const { Rate, ProductQuantity, DiscountAmount, Tax } = product;

        // Parse values to ensure proper calculations
        const tax = parseFloat(Tax);
        const rate = parseFloat(Rate);
        const quantity = parseFloat(extractNumber(ProductQuantity));
        const discount = parseFloat(DiscountAmount);

        // Step 1: Calculate Gross Amount
        const grossAmount = rate * quantity;

        // Step 1: Calculate Gross Amount
        const indiviualDiscount = (rate * quantity) * discount / 100;

        // Step 2: Calculate GST Amount
        const gstAmount = (grossAmount - indiviualDiscount) * tax / 100;

        // Step 5: Calculate Net Amount for Product
        const netAmountForProduct = BillType === "GST Bill" ? (grossAmount + gstAmount - indiviualDiscount) : (grossAmount - indiviualDiscount);

        // Aggregate totals
        totalGrossAmount += grossAmount;
        totalDiscount += indiviualDiscount;
        totalGst += gstAmount;
        netAmount += netAmountForProduct;
      });

      // Return final result in a single object
      return {
        TotalGrossAmount: totalGrossAmount.toFixed(2),
        TotalDiscount: totalDiscount.toFixed(2),
        TotalGST: totalGst.toFixed(2),
        NetAmount: netAmount.toFixed(2),
      };
    }
  };

  useEffect(async () => {
    if (userData) {
      setIsLoading(true);
      try {
        const getSupplyOrder = await getAllSupplyOrderDocument();
        setRecords(getSupplyOrder);
        setIsLoading(false);
      } catch (error) {
        console.log("Error Occur in Get Order", error)
        setIsLoading(false);
      }
    }
  }, [userData]);

  // Delete item from selectedItems
  const handleDeleteItem = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Generate Invoice" />
          <title>Generate Invoice | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {!isPreview && (
                <>
                  <h5 className="mt-3">
                    Chemist Details: &nbsp;
                    {isChemistManully ? (
                      <VisibilityOffIcon
                        onClick={() => {
                          setIsChemistManully(false)
                          setTimeout(() => {
                            mapValues(chemistEntry, (value, key) =>
                              setValue(key, value),
                            )
                          })
                        }}
                      />
                    ) : (
                      <VisibilityIcon
                        onClick={() => {
                          setIsChemistManully(true)
                          setTimeout(() => {
                            mapValues(chemistEntry, (value, key) =>
                              setValue(key, value),
                            )
                          })
                        }}
                      />
                    )}
                  </h5>
                  <div className="row mb-3">
                    <div className="col-md-7 mb-2">
                      <ReactSearchAutocomplete
                        items={chemistItems}
                        placeholder="Search Chemist..."
                        fuseOptions={{ keys: ['storeName'] }}
                        // necessary, otherwise the results will be blank
                        resultStringKeyName="storeName"
                        onSearch={handleOnSearch}
                        onHover={handleOnHover}
                        onSelect={handleOnSelectChemist}
                        onFocus={handleOnFocus}
                        autoFocus
                        formatResult={formatResultChemist}
                        styling={{
                          borderRadius: '8px',
                          zIndex: 1000,
                        }}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <span className="form-control registerEmp__textbox registerEmp__datePicker">
                        <DatePickerComponent
                          id="InvoiceDate"
                          name="InvoiceDate"
                          value={InvoiceDate}
                          cssclassName="e-outline"
                          onChange={(e) => handleInvoiceDateChange(e)}
                          ref={register()}
                          format="dd/MM/yyyy"
                          cleared={() => setInvoiceDate('')}
                        />
                      </span>
                    </div>
                  </div>
                  <div className={isChemistManully ? "row PartyManully" : "row InactivePartyManully"}>
                    <div className="col-md-5 mb-2">
                      Store Name
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="storeName"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-7 mb-2">
                      Store Address
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="storeAddress"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      Email Id
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="email"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      Contact No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="phoneNumber"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      GST No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="gstNo"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      D/L No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="drugLicense"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                  </div>
                  <h5 className="mt-2">Others Information:</h5>
                  <div className="col-md-3 mb-2">
                    Bill Type
                    <select
                      className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.BillType })}
                      aria-label="Default select example"
                      name="BillType" ref={register({
                        required: 'Please select Bill Type!',
                        validate: {
                          defaultValue: value => value !== "Select Option" || 'Please select Bill Type!'
                        }
                      })}
                      onChange={(event) => {
                        setBillType(event.target.value)
                        if (event.target.value === "GST Bill") {
                          setInvoiceNo(`SUP1000${InvoiceNoCount}`)
                        } else if (event.target.value === "Challan Bill") {
                          setInvoiceNo(`CH1000${InvoiceNoCount}`)
                        }
                      }}
                      defaultValue={BillType} >
                      <option value="GST Bill">GST Bill</option>
                      <option value="Challan Bill">Challan Bill</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-2">
                    Invoice No
                    <input
                      type="text"
                      className={classNames(
                        'form-control registerEmp__textbox',
                      )}
                      name="InvoiceNo"
                      value={InvoiceNo}
                      autoComplete="none"
                      ref={register()}
                    />
                  </div>
                  <div className='mt-4' />
                  <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                    <TabList>
                      <Tab>Branded</Tab>
                      <Tab>Generic</Tab>
                    </TabList>
                    <TabPanel>
                      <div className="branded-tab mt-4">
                        <div className="row mb-3 row--col--md--12">
                          <div className="col-md-8 mb-2 searchOrAdd">
                            <label>Search or Add Medicine</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              value={inputValue}
                              onChange={handleInputChange}
                              placeholder="Enter Name of the medicines..."
                            />

                            {/* Popup dropdown styling for suggestions */}
                            {filteredSuggestions.length > 0 && (
                              <ul>
                                {filteredSuggestions.map((suggestion) => (
                                  <li
                                    key={suggestion._id}
                                    onClick={() => handleSuggestionClick(suggestion)}
                                    style={{ padding: '8px', cursor: 'pointer', color: '#333', borderBottom: 'solid 1px #000' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                  >
                                    {suggestion.ProductName}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          <div className="col-md-3 mb-2">
                            <label>Quantity</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              placeholder="Product Quantity"
                              name="ProductQuantity"
                              autoComplete="none"
                              value={ProductQuantity}
                              onChange={(event) =>
                                setProductQuantity(event.target.value)
                              }
                              required
                              ref={register()}
                            />
                          </div>
                          <div className="col-md-1 mb-2">
                            <label>{' '}</label>
                            <div className="addBox">
                              <Button
                                onClick={onTapAddProductButton}
                                variant="contained"
                                className="registerEmp__btnLogin jsmAdd"
                              >
                                {'Add'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="generic-tab mt-4">
                        <div className="row mb-3 row--col--md--12">
                          <div className="col-md-8 mb-2 searchOrAdd">
                            <label>Search or Add Medicine</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              value={inputValue}
                              onChange={handleInputChange}
                              placeholder="Enter Name of the medicines..."
                            />

                            {/* Popup dropdown styling for suggestions */}
                            {filteredSuggestions.length > 0 && (
                              <ul>
                                {filteredSuggestions.map((suggestion) => (
                                  <li
                                    key={suggestion._id}
                                    onClick={() => handleSuggestionClick(suggestion)}
                                    style={{ padding: '8px', cursor: 'pointer', color: '#333', borderBottom: 'solid 1px #000' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                  >
                                    {suggestion.ProductName}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          <div className="col-md-3 mb-2">
                            <label>Quantity</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              placeholder="Product Quantity"
                              name="ProductQuantity"
                              autoComplete="none"
                              value={ProductQuantity}
                              onChange={(event) =>
                                setProductQuantity(event.target.value)
                              }
                              required
                              ref={register()}
                            />
                          </div>
                          <div className="col-md-1 mb-2">
                            <label>{' '}</label>
                            <div className="addBox">
                              <Button
                                onClick={onTapAddProductButton}
                                variant="contained"
                                className="registerEmp__btnLogin jsmAdd"
                              >
                                {'Add'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                  {(selectedItems && selectedItems.length > 0) ? (<>
                    <h5 className="mt-3">Product Details:</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <td>S.No</td>
                          <td>Particulars</td>
                          <td>Pack Size</td>
                          <td>Quantity</td>
                          <td>Exp Date</td>
                          <td>HSN Code</td>
                          <td>Batch No</td>
                          <td>MRP</td>
                          {BillType === "GST Bill" && <td>Tax</td>}
                          <td>Discount</td>
                          <td>Rate</td>
                          {/* {BillType === "GST Bill" && <td>SGST</td>}
                          {BillType === "GST Bill" && <td>CGST</td>} */}
                          <td>Amount</td>
                          <td>Action</td>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItems.map((item, index) => {
                          let TotalAmount = item?.Rate * extractNumber(item?.ProductQuantity);

                          const handleInputChange = (key, value) => {
                            setSelectedItems((prevItems) => {
                              const updatedItems = [...prevItems];
                              updatedItems[index][key] = value;
                              return updatedItems;
                            });
                          };

                          return (
                            <tr key={index}> {/* Use index as key if _id is not available */}
                              <td>{index + 1}</td>
                              <td>{item?.ProductName}</td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="text"
                                  value={item?.PackagingSize}
                                  onChange={(e) => handleInputChange("PackagingSize", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.ProductQuantity}
                                  onChange={(e) => handleInputChange("ProductQuantity", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="handleInput"
                                  type="text"
                                  value={item?.ExpiryDate}
                                  onChange={(e) => handleInputChange("ExpiryDate", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="handleInput"
                                  type="text"
                                  value={item?.HSNCode}
                                  onChange={(e) => handleInputChange("HSNCode", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="handleInput"
                                  type="text"
                                  value={item?.BatchNo}
                                  onChange={(e) => handleInputChange("BatchNo", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.ProductMRP}
                                  onChange={(e) => handleInputChange("ProductMRP", e.target.value)}
                                />
                              </td>
                              {BillType === "GST Bill" && (
                                <td>
                                  <input
                                    className="smallInput"
                                    type="number"
                                    value={item?.Tax}
                                    onChange={(e) => handleInputChange("Tax", e.target.value)}
                                  />
                                </td>
                              )}
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.DiscountAmount}
                                  onChange={(e) => handleInputChange("DiscountAmount", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.Rate}
                                  onChange={(e) => handleInputChange("Rate", e.target.value)}
                                />
                              </td>
                              <td>{`Rs. ${TotalAmount?.toFixed(2)}`}</td>
                              <td className="deleteCursor">
                                <DeleteIcon onClick={() => handleDeleteItem(index)} />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>) : <>
                    <h3 className='text-center mt-5 mb-5'>No Order Found for selected Chemist and Date!!</h3>
                  </>}
                </>
              )}
              {isPreview && (
                <div className="col-md-12">
                  <div className="backButton">
                    <div className="inline__block">
                      <Button
                        onClick={() => editPreview()}
                        color="error"
                        variant="outlined"
                        className="registerEmp__btnRemove"
                      >
                        <EditIcon />
                        &nbsp; {'Edit'}
                      </Button>
                    </div>
                  </div>

                  <div ref={tableRef}>
                    <table className="table mt-5">
                      <tr>
                        <td>
                          <h5 className="card-events-title product__mainTitle">
                            {userData.storeName}
                          </h5>
                          {
                            <p className="card-events-title">
                              <b>{userData.storeAddress}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              Contact No: <b>{userData.phoneNumber}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              Email Id: <b>{userData.email}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              GST No: <b>{userData.gstNo}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              DL No: <b>{userData.drugLicense}</b>
                            </p>
                          }
                        </td>
                        <td>
                          {(previewState?.storeName || previewState?.chemistEntry?.storeName) && (
                            <p className="card-events-title">
                              Party Name: <b>{previewState.storeName || previewState.chemistEntry.storeName || previewState.chemistEntry.name}</b>
                            </p>
                          )}
                          {(previewState?.storeAddress || previewState?.chemistEntry?.storeAddress) && (
                            <p className="card-events-title">
                              Address: <b>{previewState.storeAddress || previewState.chemistEntry.storeAddress}</b>
                            </p>
                          )}
                          {(previewState?.email || previewState?.chemistEntry?.email) && (
                            <p className="card-events-title">
                              Email Id: <b>{previewState?.email || previewState.chemistEntry.email}</b>
                            </p>
                          )}
                          {(previewState?.gstNo || previewState?.chemistEntry?.gstNo) && (
                            <p className="card-events-title">
                              GST No: <b>{previewState.gstNo || previewState.chemistEntry.gstNo}</b>
                            </p>
                          )}
                          {(previewState?.drugLicense || previewState.chemistEntry.drugLicense) && (
                            <p className="card-events-title">
                              DL No: <b>{previewState?.drugLicense || previewState.chemistEntry.drugLicense}</b>
                            </p>
                          )}
                          {previewState.InvoiceNo && (
                            <p className="card-events-title">
                              Invoice No: <b>{previewState.InvoiceNo}</b>
                            </p>
                          )}
                          {InvoiceDate && (
                            <p className="card-events-title">
                              Invoice Date: <b>{InvoiceDate}</b>
                            </p>
                          )}
                        </td>
                      </tr>
                    </table>
                    <table className="table" ref={xlsxTableRef}>
                      <thead>
                        <tr>
                          <td>S.No</td>
                          <td>Particulars</td>
                          <td>Pack Size</td>
                          <td>Quantity</td>
                          <td>Exp Date</td>
                          <td>HSN Code</td>
                          <td>Batch No</td>
                          <td>MRP</td>
                          {BillType === "GST Bill" && <td>Tax</td>}
                          <td>Discount</td>
                          <td>Rate</td>
                          <td>Amount</td>
                        </tr>
                      </thead>
                      <tbody>
                        {previewState &&
                          previewState?.ProductEntry &&
                          previewState?.ProductEntry?.length > 0 &&
                          previewState.ProductEntry.map((item, index) => {
                            let TotalAmount = item?.Rate * extractNumber(item?.ProductQuantity);
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{item?.ProductName}</td>
                                <td>{item?.PackagingSize}</td>
                                <td>{item?.ProductQuantity}</td>
                                <td>{item?.ExpiryDate ? item?.ExpiryDate : 'NA'}</td>
                                <td>{item?.HSNCode ? item?.HSNCode : "NA"}</td>
                                <td>{item?.BatchNo ? item?.BatchNo : "NA"}</td>
                                <td>
                                  {item?.ProductMRP
                                    ? `Rs. ${item?.ProductMRP}`
                                    : '0'}
                                </td>
                                {BillType === "GST Bill" && <td>{`${item?.Tax}`}</td>}
                                <td>{item?.DiscountAmount}</td>
                                <td>{item?.Rate}</td>
                                <td>{`Rs. ${TotalAmount?.toFixed(2)}`}</td>
                              </tr>
                            )
                          })}
                        <tr>
                          <td colSpan={BillType === "GST Bill" ? 10 : 9}></td>
                          <td>Gross Amount</td>
                          <td>{`Rs. ${finalCalculation()?.TotalGrossAmount}`}</td>
                        </tr>
                        <tr>
                          <td colSpan={BillType === "GST Bill" ? 10 : 9}></td>
                          <td>Total Discount</td>
                          <td>{`Rs. ${finalCalculation()?.TotalDiscount}`}</td>
                        </tr>
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={10}></td>
                          <td>Total GST</td>
                          <td>{`Rs. ${finalCalculation()?.TotalGST}`}</td>
                        </tr>}
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={10}></td>
                          <td>CGST</td>
                          <td>{`Rs. ${(finalCalculation()?.TotalGST / 2).toFixed(2)}`}</td>
                        </tr>}
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={10}></td>
                          <td>SGST</td>
                          <td>{`Rs. ${(finalCalculation()?.TotalGST / 2).toFixed(2)}`}</td>
                        </tr>}
                        <tr>
                          <td colSpan={BillType === "GST Bill" ? 10 : 9}>
                            Account Holder:	Butame Pharma Pvt Ltd	<br />
                            Account No:		10084890331	<br />
                            Account Type:		Current Acount <br />
                            Bank Name:		IDFC First Bank <br />
                            Bank IFSC Code:		IDFB0020132
                          </td>
                          <td><b>Net Total</b> </td>
                          <td>{`Rs. ${finalCalculation()?.NetAmount}`}</td>
                        </tr>
                        <tr></tr>
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={12}>
                            Note: We do not entertain any credit based supply of the goods.<br />
                            Please return the damaged or expired products to the delivery boy at the same time.<br />
                            For queries, contact us at: hello@kaipsool.com
                          </td>
                        </tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {(selectedItems && selectedItems.length > 0) && <div className="col-sm-12 text-right mt-2">
                <div className="d-flex justify-content-center">
                  {!isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="preview"
                        value="preview"
                        variant="contained"
                        onClick={handlePreviewSubmit}
                        className="registerEmp__btnLogin preview"
                      >
                        {'Preview'}
                      </Button>
                    </div>
                  )}
                  {isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="saved"
                        value="saved"
                        variant="contained"
                        disabled={isLoading ? true : false}
                        onClick={handleSaveSubmit}
                        className="registerEmp__btnLogin save"
                      >
                        {isLoading ? <CircularProgress size={18} /> : 'Download Invoice'}
                      </Button>
                    </div>
                  )}
                </div>
              </div>}
            </div>
          </form>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default EditSupplyOrderWithInvoice
